import ListPage from './src/main'

ListPage.install = function (Vue) {
  Vue.component(ListPage.name, ListPage)
}

export default ListPage
